import { render } from "./uiModal.vue?vue&type=template&id=5c2ba543&scoped=true"
import script from "./uiModal.vue?vue&type=script&lang=js"
export * from "./uiModal.vue?vue&type=script&lang=js"

import "./uiModal.vue?vue&type=style&index=0&id=5c2ba543&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5c2ba543"

export default script